/* Hype pages — statement copy that fills in word by word.

   Both engines feed the same applyProgress(): the GSAP path gets progress from
   a scrubbed ScrollTrigger pin, the default path measures the sticky track on
   scroll. Only the pinning differs, because position: sticky does not survive
   the transform ScrollSmoother puts on its content. */

(function () {
  function build(section) {
    var track = section.querySelector(".hype-text-scroll__track");
    var sticky = section.querySelector(".hype-text-scroll__sticky");
    var words = section.querySelectorAll(".hype-text-scroll__word");
    if (!track || !sticky || !words.length) return null;

    var lit = -1;

    function applyProgress(progress) {
      var target = Math.floor(Math.max(0, Math.min(1, progress)) * words.length);
      if (target === lit) return;
      lit = target;
      for (var i = 0; i < words.length; i++) {
        words[i].classList.toggle("is-lit", i < target);
      }
    }

    return { track: track, sticky: sticky, applyProgress: applyProgress };
  }

  function initSticky(section, parts) {
    var ticking = false;

    function measure() {
      var offset = parseFloat(getComputedStyle(parts.sticky).top) || 0;
      var distance = parts.track.offsetHeight - parts.sticky.offsetHeight - offset;
      if (distance <= 0) return null;
      return { offset: offset, distance: distance };
    }

    function update() {
      ticking = false;
      var geometry = measure();
      if (!geometry) {
        parts.applyProgress(1);
        return;
      }
      var top = parts.track.getBoundingClientRect().top;
      parts.applyProgress((geometry.offset - top) / geometry.distance);
    }

    function request() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener("scroll", request, { passive: true });
    window.addEventListener("resize", request);
    update();
  }

  function initGsap(section, parts) {
    var distance = parseFloat(section.getAttribute("data-scroll-distance")) || 100;

    window.HypeCore.ready(function () {
      ScrollTrigger.create({
        trigger: parts.track,
        start: "top top",
        /* A function is re-evaluated on every refresh, so the scrub distance
           tracks viewport height the way the vh setting implies. */
        end: function () {
          return "+=" + (distance / 100) * window.innerHeight;
        },
        scrub: true,
        pin: true,
        pinSpacing: true,
        onUpdate: function (self) {
          parts.applyProgress(self.progress);
        }
      });
    });
  }

  function initSection(section) {
    if (section.dataset.hypeTextScrollReady === "true") return;

    var parts = build(section);
    if (!parts) return;
    section.dataset.hypeTextScrollReady = "true";

    var wantsGsap =
      section.getAttribute("data-engine") === "gsap" &&
      window.HypeCore &&
      typeof gsap !== "undefined" &&
      typeof ScrollTrigger !== "undefined";

    if (wantsGsap) {
      initGsap(section, parts);
    } else {
      /* Fall back to sticky if the page claimed GSAP but never loaded it. */
      section.setAttribute("data-engine", "sticky");
      initSticky(section, parts);
    }
  }

  function init() {
    document.querySelectorAll("[data-hype-text-scroll]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
